import React from "react";
import { X } from "lucide-react";
import {
  fixtureRefId,
  isFixtureLiveStatus,
  isFixtureFinishedStatus,
  fixtureStatusShortLabel,
  fixtureScoreLabel,
} from "../../utils/bondchat/fixtureTagHelpers";

const FixtureTagCard = ({
  fixtureRef,
  isMine = false,
  variant = "timeline",
  onRemove,
}) => {
  if (!fixtureRef) return null;

  const live = isFixtureLiveStatus(fixtureRef);
  const finished = isFixtureFinishedStatus(fixtureRef);
  const score = fixtureScoreLabel(fixtureRef);
  const statusLabel = fixtureStatusShortLabel(fixtureRef);

  const homeName = fixtureRef?.homeTeam?.name || "Home";
  const awayName = fixtureRef?.awayTeam?.name || "Away";
  const homeLogo = fixtureRef?.homeTeam?.logo;
  const awayLogo = fixtureRef?.awayTeam?.logo;
  const leagueName = fixtureRef?.league?.name || "Match";
  const leagueLogo = fixtureRef?.league?.logo;

  return (
    <div
      className={[
        "bc-ftag-card",
        isMine ? "bc-ftag-card-mine" : "bc-ftag-card-other",
        live ? "bc-ftag-card-live" : "",
        finished ? "bc-ftag-card-finished" : "",
        variant === "composer" ? "bc-ftag-card-composer" : "",
      ].filter(Boolean).join(" ")}
    >
      <div className="bc-ftag-league">
        {leagueLogo ? (
          <img src={leagueLogo} alt="" className="bc-ftag-league-logo" />
        ) : (
          <span className="bc-ftag-league-fallback" aria-hidden="true">⚽</span>
        )}
        <span className="bc-ftag-league-name">{leagueName}</span>
        {onRemove && (
          <button
            type="button"
            className="bc-ftag-remove"
            onClick={onRemove}
            aria-label="Remove fixture tag"
          >
            <X size={14} />
          </button>
        )}
      </div>

      <div className="bc-ftag-match">
        <div className="bc-ftag-team">
          {homeLogo ? (
            <img src={homeLogo} alt={homeName} className="bc-ftag-team-logo" />
          ) : (
            <span className="bc-ftag-team-initials">{homeName.slice(0, 3).toUpperCase()}</span>
          )}
          <span className="bc-ftag-team-name">{homeName}</span>
        </div>

        <div className="bc-ftag-center">
          {score ? (
            <span className={`bc-ftag-score ${live ? "bc-ftag-score-live" : ""}`}>{score}</span>
          ) : (
            <span className={`bc-ftag-status-center ${live ? "bc-ftag-status-center-live" : ""}`}>
              {statusLabel}
            </span>
          )}
        </div>

        <div className="bc-ftag-team bc-ftag-team-away">
          {awayLogo ? (
            <img src={awayLogo} alt={awayName} className="bc-ftag-team-logo" />
          ) : (
            <span className="bc-ftag-team-initials">{awayName.slice(0, 3).toUpperCase()}</span>
          )}
          <span className="bc-ftag-team-name">{awayName}</span>
        </div>
      </div>
    </div>
  );
};

const FixtureTagChips = ({
  refs = [],
  isMine = false,
  variant = "timeline",
  onRemove,
}) => {
  if (!refs.length) return null;

  return (
    <div className={`bc-fixture-tags ${variant === "timeline" ? "bc-fixture-tags-timeline" : "bc-fixture-tags-composer"}`}>
      {refs.map((fixtureRef, index) => {
        const id = fixtureRefId(fixtureRef) || `fixture-${index}`;
        return (
          <FixtureTagCard
            key={id}
            fixtureRef={fixtureRef}
            isMine={isMine}
            variant={variant}
            onRemove={onRemove ? () => onRemove(fixtureRef) : undefined}
          />
        );
      })}
    </div>
  );
};

export default FixtureTagChips;
